export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11274.7e849de0.jpg";